/*
 * @Author: Michael 
 * @Date: 2019-03-13 11:21:14 
 * @Last Modified by: wufan
 * @Last Modified time: 2020-06-24 14:58:46
 */
import Vue from 'vue';
import store from '@/store';
import CONFIG from '@/common/config';
import fetch from '@/common/api/fetch';
import getActivityType from '@/common/utils/getActivityType';
import getUrlParam from '@/common/utils/getUrlParam';
import getRedirectUrl from '@/common/utils/getRedirectUrl';

import dealRouterPath from '@/common/filters/dealRoutePath';
import { AxiosPromiseData, AxiosPromiseError } from '@/common/interface';


// 获取openId
export default function getOpenId(): Promise<any> {
  console.log('window.location.href', window.location.href)
  const _appId = getUrlParam('appId') as string;
  const _appid = getUrlParam('appid') as string
  const appId: string =  _appId ? _appId : _appid ;
  const code: string = getUrlParam('code') as string;
  const activityType: string = getActivityType();
  if(activityType === "distributeType"){
    const codeData = {
      code
    }
    return fetch.Sales('anon/show/customer/fetchWechatUserInfo', codeData).then((res: AxiosPromiseData) => {
      const { openId, headImgUrl, nickName } = res.result;
      store.dispatch('changeOpenId', { openId });
      store.dispatch('changeAvatar', headImgUrl);
      if (!nickName) {
        console.log('获取nickname失败');
        Vue.$toast.error('获取nickname失败');
      } else {
        store.dispatch('changeNickname', nickName);
      }
    }).catch((error: AxiosPromiseError) => {
      if (error.resultCode === 1114) {  // code已经被使用的情况，重新注册微信api
        window.location.replace(getRedirectUrl());
      } else {
        Vue.$toast.error(error.resultMsg);
      }
    });
  }else{
    const data = {
      appId,
      code
    };
    return fetch.post('c/wechat/openid', data).then((res: AxiosPromiseData) => {
      const data = res.data;
      store.dispatch('changeOpenId', { openId: data.openId });
      
    }).catch((error: AxiosPromiseError) => {
      if (error.resultCode === 1114) {  // code已经被使用的情况，重新注册微信api
        window.location.replace(getRedirectUrl());
      } else {
        Vue.$toast.error(error.resultMsg);
      }
    });
  }
}